import { Filter } from "@/models/Pageable"

export class FilterSearch extends Filter {
  q?: string
  withDeleted?: boolean

  constructor(props) {
    super(props)

    this.q = props.q ?? ""
    this.withDeleted = props.withDeleted ?? false
  }

  getJsonObj() {
    const data = {
      q: this.q,
      withDeleted: this.withDeleted
    }
    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterSearch(props)
  }

  static createDefault() {
    const props = {
      q: "",
      withDeleted: false
    }

    return new FilterSearch(props)
  }
}
